import { render, staticRenderFns } from "./CosPopup.vue?vue&type=template&id=0f78d764&scoped=true&"
import script from "./CosPopup.vue?vue&type=script&lang=ts&"
export * from "./CosPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CosPopup.vue?vue&type=style&index=0&id=0f78d764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f78d764",
  null
  
)

export default component.exports